import { componentScript, fullScript, scriptFullKey } from '@/utils/script-utils'

export default {
  namespaced: true,
  state: {
    scriptType: scriptFullKey,
    scriptComponents: []
  },
  mutations: {
    setScriptType(state, payload) {
      state.scriptType = payload.scriptType.length ?
        payload.scriptType : scriptFullKey
      state.scriptComponents = payload.scriptComponents
    }
  },
  actions: {
    setScriptType({ commit }, value) {
      commit('setScriptType', value)
    }
  },
  getters: {
    scriptType: state => state.scriptType,
    scriptByType: state => state.scriptType === scriptFullKey ?
      fullScript : componentScript,
    components: state => state.scriptComponents.length ?
      state.scriptComponents.join(',') : ''
  }
}
